import { Label, LabelColor } from "@dgs/core";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { HotelStayStatus } from "../../../shared/types/hotel";

interface Props {
	status: HotelStayStatus;
	isCancellationRequested: boolean;
}

export const HotelStayStatusLabel: FC<Props> = ({ status, isCancellationRequested }) => {
	const { t } = useTranslation();
	const text = useMemo(() => {
		if (isCancellationRequested) return t("Status: Cancellation requested");
		else if (status === HotelStayStatus.INQUIRY) {
			return t("Status: Inquiry");
		}
		return t("Status: Processed");
	}, [isCancellationRequested, status, t]);

	const color: LabelColor = useMemo(() => {
		if (isCancellationRequested || status === HotelStayStatus.INQUIRY) {
			return "warning";
		}
		return "success";
	}, [isCancellationRequested, status]);

	return <Label color={color}>{text}</Label>;
};
